import { Badge, Drawer, Space, Tabs, Typography } from "antd";
import { OcppMessageLog } from "../OcppMessages/OcppMessageLog";
import { SocketDataLog } from "../OcppMessages/SocketDataLog";
import { SOCKET_DETAILS_FILTER_PREFIX } from "./useSocketDetails";

type SocketDetailsDrawerProps = {
  site_id: string;
  socket_id: string | null;
  connected: boolean;
  onClose: () => void;
};

export const SocketDetailsDrawer = ({
  site_id,
  socket_id,
  connected,
  onClose,
}: SocketDetailsDrawerProps) => (
  <Drawer
    open={socket_id !== null}
    onClose={onClose}
    width="min(1400px, 92vw)"
    destroyOnClose
    title={
      <Space>
        <Badge status={connected ? "success" : "default"} />
        <span>Charger</span>
        <Typography.Text code>{socket_id}</Typography.Text>
      </Space>
    }
  >
    {socket_id !== null && (
      <Tabs
        items={[
          {
            key: "ocpp",
            label: "OCPP messages",
            children: (
              <>
                <Typography.Paragraph type="secondary">
                  The OCPP messages the broker relayed between this charger and
                  the CPMS. Click a row to see the request next to its response.
                </Typography.Paragraph>
                <OcppMessageLog
                  site_id={site_id}
                  socket_id={socket_id}
                  filterPrefix={SOCKET_DETAILS_FILTER_PREFIX}
                />
              </>
            ),
          },
          {
            key: "data",
            label: "Measurements & transactions",
            children: (
              <>
                <Typography.Paragraph type="secondary">
                  The measurements and transactions stored for the assets this
                  charger is currently mapped to in the socket-to-asset map.
                  Click a row to see the full record.
                </Typography.Paragraph>
                <SocketDataLog
                  site_id={site_id}
                  socket_id={socket_id}
                  filterPrefix={SOCKET_DETAILS_FILTER_PREFIX}
                />
              </>
            ),
          },
        ]}
      />
    )}
  </Drawer>
);
